<template lang="pug">
  //- UNCOMMENT IF YOU DO NOT WANT PEOPLE TO INTERACT WITH THIS PART OF THE WEBAPP (and make sure to comment the other div out)
  //- div(:style="{display:'block', textAlign:'center'}")
  //-   img(src='@/assets/img/currentPositionsBlur.png' alt='usit photo' :style="{height:'40vh', borderLeftStyle:'solid'}")
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Rankings
    md-card-content
      .md-layout
        .md-layout-item
          h4 Your Current Rank: <b>{{curRank}}</b>
      md-table(v-model="portfolios")
        md-table-toolbar
          .md-layout.md-alignment-center-space-between(style="width: 60%")              
            .md-layout-item
              p Page Size
              md-field
                md-select(v-model="page_size" placeholder="Select...")
                  md-option(:value="20") 20
                  md-option(:value="50") 50
                  md-option(:value="100") 100
            .md-layout-item
              md-button(@click="getPortfolios") Apply
        md-table-row(slot="md-table-row" slot-scope="{ item, index }")
          md-table-cell(md-label="Rank") {{item.rank}}
          md-table-cell(md-label="Name") {{item.initials}}
          md-table-cell(md-label="Total") ${{formatNumber(item.total)}}
          md-table-cell(md-label="Returns") {{Number(item.returns).toFixed(2)}}%
      .md-layout.md-alignment-center-center
        .md-col-5
          a(@click="setPage(1)")
            md-avatar.md-avatar-icon.c-avatar
              small.c-small First
          a(v-if="page != 1" @click="setPage(page-1)")
            md-avatar.md-avatar-icon.c-avatar
              small.c-small {{page-1}}
          a(@click="setPage(page)")
            md-avatar.md-avatar-icon.c-avatar
              small.c-small.selected-avatar {{page}}
          a(v-if="page != lastPage" @click="setPage(page + 1)")
            md-avatar.md-avatar-icon.c-avatar 
              small.c-small {{page + 1}}
          a(@click="setPage(lastPage)")
            md-avatar.md-avatar-icon.c-avatar 
              small.c-small Last
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: null,
      portfolios: null,
      error: null,
      page: 1,
      page_size: 20,
      lastPage: 1,
      curRank: null,
    }
  },
  created() {

  },
  mounted() {
    this.user = this.$store.state.user;
    this.getPortfolios();
  },
  methods: {
    getPortfolios() {
      axios.get(`/api/trading/member_portfolio?page=${this.page}&page_size=${this.page_size}`)
      .then((res) => {
        this.portfolios = res.data.results;
        this.lastPage = res.data.total_pages;
      }).catch((err) => {
        this.error = true;
      })
      axios.get(`/api/trading/member_portfolio_dash/${this.$store.state.user.id}`)
      .then((res) => {
        this.curRank = res.data.rank;
      }).catch((err) => {
        this.error = true;
      });
    },
    formatNumber(n) {
      var parts=n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
    },
    setPage(n) {
      this.page = n;
      this.getPortfolios();
    }
  }
}
</script>

<style>
  .c-small {
    font-size: .7em;
  }
  .c-avatar {
    margin-right: 5px;
    margin-left: 5px;
  }
  .selected-avatar {
    color:rgba(0, 0, 0, 0.836);
  }
</style>


// WEBPACK FOOTER //
// src/pages/Trading/Rankings.vue